import { render, staticRenderFns } from "./adminCarDetailList.vue?vue&type=template&id=2709872d&scoped=true"
import script from "./adminCarDetailList.vue?vue&type=script&lang=js"
export * from "./adminCarDetailList.vue?vue&type=script&lang=js"
import style0 from "./adminCarDetailList.vue?vue&type=style&index=0&id=2709872d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2709872d",
  null
  
)

export default component.exports